import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.875 13.125H11.3125V15H1.9375C1.42 15 1 14.58 1 14.0625V0.9375C1 0.42 1.42 0 1.9375 0H11.3125V1.875H2.875V13.125ZM14.5131 7.5L10.375 11.6381L9.04938 10.3125L10.9244 8.4375H4.75V6.5625H10.9244L9.04938 4.6875L10.375 3.36187L14.5131 7.5Z",
		fill: "currentColor"
	})
});
export default SvgIconLogout;
